import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import { useIntl } from "react-intl";
import Button, {
  COLOR,
  VARIANT,
  SIZE,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { th } from "date-fns/locale";
import { StyledStep1ListItem } from "./TelegramSetting.styles";
import { useTheme } from "@mui/styles";

const TelegramAnalyticsSettingStep2 = ({ onPrevStep, onNextStep }) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  return (
    <Box padding="0 30px" className="fade-up-more">
      <Box component={Grid} container spacing={5} alignItems="center">
        <Box component={Grid} item xs={12} sm={6}>
          <Box>
            <Box>
              <Box
                fontSize={"24px"}
                fontWeight={"700"}
                color={(theme) => theme.customColors.grey[700]}
                mb="32px"
              >
                {formatMessage({
                  id: "telegramAnalyticsBot.integrationWizard.step2.title",
                })}
              </Box>

              <StyledStep1ListItem>
                1.
                {formatMessage({
                  id: "telegramAnalyticsBot.integrationWizard.step2.instruction1",
                })}
              </StyledStep1ListItem>
              <StyledStep1ListItem>
                2.
                {formatMessage({
                  id: "telegramAnalyticsBot.integrationWizard.step2.instruction2",
                })}
              </StyledStep1ListItem>
              <StyledStep1ListItem>
                3.{" "}
                {formatMessage({
                  id: "telegramAnalyticsBot.integrationWizard.step2.instruction3",
                })}
              </StyledStep1ListItem>

              <Box
                sx={{
                  color: theme.customColors.grey[500],
                  marginTop: "32px",
                  display: "flex",
                }}
              >
                <Box
                  color={theme.customColors.grey[500]}
                  className="meta-crm-icon-ic_info font-size-14"
                  sx={{
                    marginRight: "5px",
                    display: "inline-block",
                    transform: "translateY(2px)",
                  }}
                />
                <Box>
                  {formatMessage({
                    id: "telegramAnalyticsBot.integrationWizard.step2.explanation",
                  })}
                </Box>
              </Box>
            </Box>
            <Box mt="48px">
              <Button sx={{ width: "120px" }} onClick={onNextStep}>
                {formatMessage({ id: "global.btn.next" })}
              </Button>
            </Box>
          </Box>
        </Box>
        <Box component={Grid} item xs={12} sm={6}>
          <Box sx={{ backgroundColor: "#FAFAFD", padding: "17px 13px" }}>
            <Box
              sx={{
                fontWeight: "700",
                color: theme.customColors.grey[700],
                marginBottom: "32px",
              }}
            >
              <Box
                sx={{
                  color: theme.customColors.purple[500],
                  display: "inline-block",
                }}
              >
                img 02 .
              </Box>
              {formatMessage({
                id: "telegramAnalyticsBot.integrationWizard.step2.imgTitle",
              })}
            </Box>
            <Box
              sx={{ margin: "0 auto", display: "block" }}
              component={"img"}
              src={require("assets/img/tg-analytics-setting-step2.png")}
              width={"279px"}
            ></Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TelegramAnalyticsSettingStep2;
